<div
  class="c-celebration-dialog"
  [class.c-celebration-dialog--visible]="celebrating"
  [class.c-celebration-dialog--success]="variant === 'success'"
  [class.c-celebration-dialog--error]="variant === 'error'"
  [attr.role]="variant === 'error' ? 'alert' : 'status'"
  [attr.aria-live]="variant === 'error' ? 'assertive' : 'polite'"
  [attr.aria-hidden]="celebrating ? null : 'true'"
  aria-atomic="true"
>
  <div class="c-celebration-dialog__wrapper">
    <div class="c-celebration-dialog__title">
      {{ title }}
      @if (titleIcon) {
        <ion-icon [name]="titleIcon" aria-hidden="true"></ion-icon>
      }
    </div>
    <div class="c-celebration-dialog__description">
      {{ message }}
    </div>
  </div>
</div>
